import ArticlePage from "./ArticlePage";
import { navLinks, person } from "../data/site";

const NotFoundPage = () => {
  const seo = {
    path: "/404",
    title: `Page not found | ${person.name}`,
    description: `This page does not exist on ${person.name}'s website.`,
  };

  return (
    <ArticlePage
      seo={seo}
      theme="dark"
      bigTitle="404"
      heading="Page not found"
      related={navLinks}
      noindex
    >
      <p>
        This page is not available. Use the home button above or the links below
        to continue.
      </p>
    </ArticlePage>
  );
};

export default NotFoundPage;
